import { render } from "./LbrxDisplayBiatSecondTheme.vue?vue&type=template&id=66cacc7a&scoped=true"
import script from "./LbrxDisplayBiatSecondTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayBiatSecondTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplayBiatSecondTheme.vue?vue&type=style&index=0&id=66cacc7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cacc7a"]])

export default __exports__